<template>
  <section class="products">
    <div class="products-header">
      <aside class="products-title">
        <h2>Nuestros Productos</h2>
        <p>Por unas mejores alternativas de calidad y precios para nuestro clientes</p>
      </aside>
      <aside class="products-button">
        <button @click="redirect('productos')">Ver mas</button>
      </aside>
    </div>
    <swiper ref="{swiperRef}" :breakpoints="{
      '0': {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      '480': {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      '650': {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      '768': {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      '980': {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      '1200': {
        slidesPerView: 4,
        spaceBetween: 15,
      }}" :slidesPerView="4" :centeredSlides="false" :spaceBetween="20" :navigation="true" :modules="modules"
      class="mySwiper list">

      <swiper-slide v-for="product in products" :key="product.id">
        <CardProduct :product="product" />
      </swiper-slide>

    </swiper>
  </section>
</template>


<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import '../styles/CarouselProducts.style.scss';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


// import required modules
import { Pagination, Navigation } from 'swiper/modules';
import { ref } from 'vue';
import products from "@/data/products.json";
import { useRouter } from 'vue-router';

import CardProduct from "@/components/Card/CardProduct.component.vue";

const modules =  ref([Pagination, Navigation]);
const route = useRouter();

function redirect(path) {
  route.push({ name: path });
}

</script>

<style lang="scss" scoped>
.products {
    padding-inline: 300px;
    display: flex;
    flex-direction: column; 
    gap: 12px;
    margin-top: 100px;
    .products-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .products-title {
        display: flex;
        flex-direction: column; 
        gap: 12px;
      }
      .products-button {
        button {
          padding: 10px 20px;
          border: 1px solid $tint4;
          background: none;
          color: $tint2;
          border-radius: 5px;
          cursor: pointer;
          transition: background-color 0.3s ease;

          &:hover {
            background-color: $tint4;
          }
        }
      }
    }
    h2 {
        font-size: 36px;
        font-weight: 600;
        color: $shade1;
        text-align: start;
        margin: 0;
    }
    p {
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
        text-align: start;
        margin: 0;
    }
    .list {
        margin-top: 40px;
    }
}

@media (max-width: 1600px) {
    .products {
        padding-inline: 100px;
        h2 {
          font-size: 32px
        }
    }
}
@media (max-width: 1080px) {
    .products {
        padding-inline: 80px;
        h2 {
          font-size: 24px
        }
        .products-header {
          display: flex;
          align-items: start;
          flex-direction: column;
          gap: 20px;
        }
    }
}

@media (max-width: 580px) {
    .products {
        padding-inline: 20px;
    }
}
</style>